import { render, staticRenderFns } from "./PropertyMultiselect.vue?vue&type=template&id=12e4b5f1&scoped=true"
import script from "./PropertyMultiselect.vue?vue&type=script&lang=ts"
export * from "./PropertyMultiselect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e4b5f1",
  null
  
)

export default component.exports